import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=8d8c7f60&scoped=true&"
var script = {}
import style0 from "./Page404.vue?vue&type=style&index=0&id=8d8c7f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c7f60",
  null
  
)

export default component.exports